import PopUpModulBtn from "../PopUpModulBtn";
import { MdMailOutline } from "react-icons/md";

const ContactBandBtnLogic = ({ mail }) => {
  return (
    <>
      {/* Hidden mailadress - user must log in to send mail */}
      {mail === "hidden" ? (
        <div className="w-full">
          <PopUpModulBtn
            btnText="Kontakta"
            modalId="contact"
            title="Bli medlem"
            text="För att kunna ta kontakt behöver du vara medlem"
            btnStyle="w-full btn-outline border-neutral-700 text-stone-300 hover:bg-stone-800 hover:text-white"
          >
            <p>
              Du kan skapa ett konto helt gratis.{" "}
              <a className="text-primary" href="/register">
                Skapa konto här
              </a>
            </p>
          </PopUpModulBtn>
        </div>
      ) : (
        <>
          {/* Mailadress is visible */}
          <div className="w-full">
            <a href={`mailto:${mail}`} className="block w-full">
              <button className="btn btn-outline border-neutral-700 text-stone-300 hover:bg-stone-800 hover:text-white w-full">
                Kontakta <MdMailOutline />
              </button>
            </a>
          </div>
        </>
      )}
    </>
  );
};

export default ContactBandBtnLogic;
